import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material';
import {DictionaryService} from '../../../services/dictionary.service';
import {Utils} from '../../../../../common/services/Utils';
import {Language} from '../../../../../common/models/language';
import {LangChange} from '../../../../../lang-change';
import {DirectionOfSpecialityEditModalComponent} from './direction-of-speciality-edit-modal/direction-of-speciality-edit-modal.component';
import {ModuleENUM} from '../../../../../common/enums/module.enum';
import {ModuleExtendedEdit} from '../../../../../common/enums/module-extended-edit.enum';
import {Principal} from '../../../../../common/services/principal';

@Component({
  selector: 'app-direction-of-speciality-list',
  templateUrl: './direction-of-speciality-list.component.html',
  styleUrls: ['./direction-of-speciality-list.component.scss']
})
export class DirectionOfSpecialityListComponent extends LangChange implements OnInit {

  langId: number;
  searchText: string;
  dictList = [];
  hasWriteAccess = false;
  constructor(protected _translateService: TranslateService,
              private _router: Router,
              private _dialog: MatDialog,
              private _dictionaryService: DictionaryService,
              private _principal: Principal,
              private _utils: Utils) {
    super(_translateService);
    this.langId = Language.getCurrentLanguage().id;
  }

  ngOnInit() {
    this.reloadList();
    this.hasWriteAccess = this._principal.isAdmin() ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
  }

  reloadList() {
    this._dictionaryService.getDicDirectionOfSpecialtyList().subscribe(
      list => {
        this.dictList = list;
      }
    );
  }

  onEdit(dto) {
    this._dialog.closeAll();
    const dialogRef = this._dialog.open(DirectionOfSpecialityEditModalComponent, {
      width: '900px',
      data: dto
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.reloadList();
        }
      }
    );
  }

  deleteById(item) {
    this._dictionaryService.deleteDicDirectionOfSpecialty(item.id).subscribe(resp => {
      this._utils.notifySuccess('common.deleted_successfully', null);
      this.reloadList();
    });
  }

  onLangChange(langCode): void {
    this.langId = langCode.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/dictionary/direction-of-speciality-list/direction-of-speciality-list.component.ts